import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  ComponentRef,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ScDialogComponent, ScDialogData } from '../../../models';

@Component({
  selector: 'sc-generic-dialog',
  templateUrl: './sc-generic-dialog.component.html',
  styleUrls: ['./sc-generic-dialog.component.scss']
})
export class ScGenericDialogComponent implements AfterViewChecked, OnInit, OnDestroy {
  @ViewChild('content', { static: true, read: ViewContainerRef })
  content: ViewContainerRef;

  public data: ScDialogData;
  public componentRef: ComponentRef<ScDialogComponent>;

  constructor(
    private _dialogRef: MatDialogRef<ScGenericDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public _data: ScDialogData,
    private _cfr: ComponentFactoryResolver,
    private _cd: ChangeDetectorRef
  ) {
    this.data = this._data;
  }

  public ngOnInit() {
    const cmpFactory = this._cfr.resolveComponentFactory(this.data.componentRef);
    this.componentRef = this.content.createComponent(cmpFactory);
    this.componentRef.instance.isForFormly = this.data.isForFormly;

    if (this.data.data) {
      this.componentRef.instance.data = this.data.data;
    }

    if (this.data.formFields) {
      this.componentRef.instance.formFields = this.data.formFields;
    }

    if (this.data.tabs) {
      this.componentRef.instance.tabs = this.data.tabs;
    }

    this.componentRef.changeDetectorRef.markForCheck();
  }

  public ngAfterViewChecked(): void {
    this._cd.detectChanges(); // to prevent expression after view checked
  }

  public onSubmit(): void {
    const formData = this.data.isForFormly
      ? {
          ...this.componentRef.instance['formlyForm']['model'],
          ...this.componentRef.instance['formlyForm']['form']['value']
        }
      : this.componentRef.instance.form
      ? this.componentRef.instance.form.value
      : {};
    const data = {
      ...this.componentRef.instance.data,
      ...formData
    };

    this._dialogRef.close(data);
  }

  public onClose(): void {
    this._dialogRef.close(false);
  }

  public trackByIndex = (index: number): number => index;

  public ngOnDestroy(): void {
    this.componentRef.instance.formFields = [];
    this.componentRef.instance.form = null;
    this.componentRef.instance.data = null;
    this.componentRef.destroy();
  }
}
